import { render, staticRenderFns } from "./abnormalCount.vue?vue&type=template&id=3610601c&scoped=true"
import script from "./abnormalCount.vue?vue&type=script&lang=js"
export * from "./abnormalCount.vue?vue&type=script&lang=js"
import style0 from "./abnormalCount.vue?vue&type=style&index=0&id=3610601c&prod&lang=css"
import style1 from "./abnormalCount.vue?vue&type=style&index=1&id=3610601c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3610601c",
  null
  
)

export default component.exports